import { computed, defineComponent, ref } from 'vue';
import { useStore } from '@/store';
export default defineComponent({
    components: {
        sidebarItem: () => import('./sidebarItem.vue')
    },
    setup() {
        const drawer = ref(true);
        const store = useStore();
        const menus = computed(() => store.getters['menu/menus']);
        return {
            drawer,
            menus
        };
    }
});
